import { createEffect, createEvent, createStore } from 'effector';
import { callsApi } from '../../api';
import { Call, CallsDataResponse } from './types';

export const CALL_EVENT = 'contact-center-calls:call';

export const $contactCalls = createStore<Call[]>([]);

export const fxGetContactCalls = createEffect<void, CallsDataResponse, Error>(
  callsApi.getContactCalls
);

export const clearEndedCalls = createEvent();
export const fxClearEndedCalls = createEffect<void, CallsDataResponse, Error>(
  callsApi.clearEndedCalls
);
